module.exports = __webpack_public_path__ + "img/chevron_left_icon.d27c68bf.svg";